

import { useParams } from "react-router-dom";
import { CargandoMedio, FormCreateUpdateMedida } from "../../components";
import { DisenioPaginas } from "../../layout";
import { useUnidadMedidaXID } from "../../../hooks";







export const CrearUnidadMedida = () => {



    const { id } = useParams();
    const { medidasXIDQuery } = useUnidadMedidaXID(id);
  
  
    const initialState = (medidasXIDQuery?.data)
      ? { nombre: medidasXIDQuery?.data.nombre }
      : { nombre: '' }




  return (

      <DisenioPaginas titulo={`${(id != 'new') ? 'Actualizar' : 'Crear'} Unidad de Medida`} url={1} add={false} subtitulo="Información de unidad de medida">
          {(medidasXIDQuery.isLoading)
          ?   <CargandoMedio titulo="Cargando unidad de medida..." />
          :   <FormCreateUpdateMedida initialState={initialState} />
          }
      </DisenioPaginas>
  )
}
